//
// RelationalQuery.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../QueryBase";
import "../common/Axis";

var RelationalQuery = createModule("BIRD::RelationalQuery", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::QueryBase"], EventDispatcher, [
    ,
    {
        columnTotals: 2,
        axes: [1],
        detail: 2,
        excludeDuplicates: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default RelationalQuery;
